export { default as PropertyAreaText } from './property-area-text.jsx';
export { default as PropertyInfoCard } from './property-info-card.jsx';
export { default as PropertyPriceText } from './property-price-text.jsx';
export { default as PropertySchema } from './property-schema.jsx';
